import { RG_TYPE } from "@project-rouge/rg-core";
import { getPivot, applyTransform, Vector3toV3 } from "@project-rouge/rg-three";
function getApartmentEntryPosition(apt, pivot = [0.5, 0, 0]) {
  for (const module of apt.children.filter((c) => c.type === RG_TYPE.Module)) {
    for (const wall of module.children.filter((c) => c.type === RG_TYPE.Wall)) {
      const door = wall.children.find((c) => c.type === RG_TYPE.Door && c.data.isEntrance);
      if (door) {
        const doorPivot = getPivot(pivot, door);
        const doorPos = applyTransform(applyTransform(doorPivot, wall), module);
        return Vector3toV3(doorPos);
      }
    }
  }
  return Vector3toV3(getPivot([0.5, 0, 0], apt));
}
export {
  getApartmentEntryPosition
};
//# sourceMappingURL=index77.js.map
